export default "__VITE_ASSET__18d970ed__"